import type { ChipProps } from "@mui/material";
import type { ReactNode } from "react";

import { isHighlightedId } from "./highlighted-ids.utils";
import { TechnicalNameChip } from "./technical-name-chip";

type TBoundMultiselectOptionId = string | number;

export type THighlightedBoundMultiselectGetItemProps = (args: {
  index: number;
}) => { key: number | string } & Omit<ChipProps, "label">;

/** MUI `renderValue` with `freeSolo` types values as `(string | number | boolean)[]`. */
export const renderHighlightedBoundMultiselectValue = ({
  values,
  getItemProps,
  getOptionLabel,
  highlightedIdKeys,
  highlightedTooltip,
}: {
  values: readonly (TBoundMultiselectOptionId | boolean)[];
  getItemProps: THighlightedBoundMultiselectGetItemProps;
  getOptionLabel: (value: string | number) => string;
  highlightedIdKeys: ReadonlySet<string>;
  highlightedTooltip?: string;
}): ReactNode =>
  values.map((option, index) => {
    const { key, ...chipProps } = getItemProps({ index });
    const optionId = option as TBoundMultiselectOptionId;
    const isHighlighted = isHighlightedId({
      option: optionId,
      highlightedIdKeys,
    });

    return (
      <TechnicalNameChip
        key={key}
        label={getOptionLabel(optionId)}
        isHighlighted={isHighlighted}
        highlightTooltip={isHighlighted ? highlightedTooltip : undefined}
        chipProps={chipProps}
      />
    );
  });
